import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Button, Text } from '../../../../../components';

const StyledButton = styled(Button)`
  border-radius: 6px;
  border: ${(props) =>
    props.$isActive ? '1px solid var(--primary-default)' : '1px solid var(--border-light)'};
`;

const PickerButton = ({ label, onClick, period, value }) => (
  <StyledButton
    naked={period !== value}
    onClick={onClick}
    secondary={period === value}
    $isActive={period === value}
  >
    <Text $color={period === value ? 'var(--content-body)' : 'var(--content-subtitle)'}>
      {label}
    </Text>
  </StyledButton>
);

PickerButton.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  period: PropTypes.string.isRequired
};

export { PickerButton };
